var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"base-form-content"},_vm._l((_vm.list),function(it,index){return _c('form-item',{key:'it' + it.itemConfig.prop + index,ref:it.itemConfig && it.itemConfig.ref,refInFor:true,attrs:{"it":it,"model":_vm.model}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }